<template>
  <div class="banner-wrap">
    <div class="background-decoration">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
    </div>
    <div class="inner">
      <v-container>
        <v-row align="center" justify="center" class="responsiceDesign">
          <v-col col="12" md="7" class="px-5">
            <div class="text">
              <div class="title-badge mb-4">
                <v-icon color="primary" class="mr-2">mdi-office-building</v-icon>
                <span class="text-subtitle-2 primary--text font-weight-bold">
                  {{ $t('brand.name') }}
                </span>
              </div>
              <h4 class="text-h3 font-weight-black mb-4 primary--text" style="line-height: 1.2;">
                {{ title }}
              </h4>
              <h5 class="text-h6 text--secondary mb-6" style="line-height: 1.7;">
                {{ dec }}
              </h5>
              <div class="stats-row">
                <div class="stat-item">
                  <div class="stat-number primary--text">5+</div>
                  <div class="stat-label text--secondary">{{ $t('landing.years') }}</div>
                </div>
                <div class="stat-divider"></div>
                <div class="stat-item">
                  <div class="stat-number secondary--text">100+</div>
                  <div class="stat-label text--secondary">{{ $t('landing.projects') }}</div>
                </div>
                <div class="stat-divider"></div>
                <div class="stat-item">
                  <div class="stat-number accent--text">50+</div>
                  <div class="stat-label text--secondary">{{ $t('landing.clients') }}</div>
                </div>
              </div>
            </div>
            <v-btn
              v-if="button"
              :to="localePath(button.to)"
              x-large
              color="primary"
              elevation="4"
              class="button mt-8 text-none px-8"
            >
              <v-icon left>{{ button.icon || 'mdi-arrow-right' }}</v-icon>
              {{ button.name }}
            </v-btn>
          </v-col>
          <v-col col="12" md="5" class="px-5">
            <div class="img">
              <div class="image-wrapper">
                <img draggable="false" :src="src" alt="illustration" />
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "./about-style.scss";

.banner-wrap {
  position: relative;
  overflow: hidden;
}

.background-decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;

  .circle {
    position: absolute;
    border-radius: 50%;
    opacity: 0.06;

    &.circle-1 {
      width: 400px;
      height: 400px;
      top: -100px;
      right: -100px;
      background: radial-gradient(circle, #3f51b5 0%, transparent 70%);
      animation: float 20s ease-in-out infinite;
    }

    &.circle-2 {
      width: 300px;
      height: 300px;
      bottom: -50px;
      left: -50px;
      background: radial-gradient(circle, #f44336 0%, transparent 70%);
      animation: float 15s ease-in-out infinite reverse;
    }

    &.circle-3 {
      width: 200px;
      height: 200px;
      top: 50%;
      left: 50%;
      background: radial-gradient(circle, #304ffe 0%, transparent 70%);
      animation: float 25s ease-in-out infinite;
    }
  }
}

.title-badge {
  display: flex;
  align-items: center;
  opacity: 0.9;
}

.stats-row {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 32px;
  flex-wrap: wrap;
}

.stat-item {
  text-align: center;

  .stat-number {
    font-size: 2rem;
    font-weight: 900;
    line-height: 1;
    margin-bottom: 4px;
  }

  .stat-label {
    font-size: 0.875rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
}

.stat-divider {
  width: 1px;
  height: 40px;
  background: rgba(0, 0, 0, 0.12);

  .theme--dark & {
    background: rgba(255, 255, 255, 0.12);
  }
}

.image-wrapper {
  position: relative;
  animation: floatImage 6s ease-in-out infinite;

  img {
    filter: drop-shadow(0 20px 40px rgba(63, 81, 181, 0.2));
  }
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(30px, 30px);
  }
}

@keyframes floatImage {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}

@media only screen and (max-width: 960px) {
  .stats-row {
    justify-content: center;
  }

  .stat-divider {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .responsiceDesign {
    flex-direction: column-reverse;
  }

  .text {
    text-align: center;

    h4 {
      font-size: 2rem !important;
    }
  }

  .title-badge {
    justify-content: center;
  }

  .stats-row {
    gap: 16px;
  }

  .stat-item {
    .stat-number {
      font-size: 1.5rem;
    }

    .stat-label {
      font-size: 0.75rem;
    }
  }

  .button {
    width: 100%;
  }
}
</style>
<script>
export default {
  props: {
    src: {
      default: () => "/images/about.svg"
    },
    title: {
      default: () => ""
    },
    button: {
      default: () => undefined
    },
    dec: {
      default: () => ""
    }
  }
};
</script>
